import { useComment } from '../hooks/useComment'
import { CommentList } from './CommentList'

type Props = {
  coordinateId: number
  memberId: number
  nickName: string
  onButtonClick: () => void
}

export const CommentForPc: React.FC<Props> = ({
  coordinateId,
  memberId,
  nickName,
  onButtonClick,
}) => {
  const { comments, restCommentsCount, hasMoreComments } =
    useComment(coordinateId)

  return (
    <div className="border-t border-gray-300 bg-white pt-5">
      <div className="px-[23px]">
        <h2 className="text-[16px] font-bold leading-none">
          {nickName}さんへのコメント
        </h2>
        {hasMoreComments && (
          <p className="pb-1 pt-[18px] text-[13px] leading-none">
            他{restCommentsCount}件のコメントを
            <button
              onClick={onButtonClick}
              type="button"
              className="leading-none text-blue-500 hover:underline"
            >
              スマートフォン用アプリ
            </button>
            で表示
          </p>
        )}
        <div className="pb-[30px]">
          {comments.length > 0 ? (
            <CommentList memberId={memberId} comments={comments} />
          ) : (
            <p className="pb-[50px] pt-[60px] text-center text-[19px]">
              NO COMMENT
            </p>
          )}
        </div>
      </div>
      <p className="border-t border-gray-200 bg-white py-8 text-center text-[16px] leading-none">
        コメントは
        <button
          onClick={onButtonClick}
          type="button"
          className="text-blue-500 hover:underline"
        >
          スマートフォン用アプリ
        </button>
        からご利用できます
      </p>
    </div>
  )
}
